import React from "react";
import { Badge } from "flowbite-react";
import { X as XIcon, ArrowCounterClockwise } from "@phosphor-icons/react";

export interface ActiveFilter {
  id: string;
  label: string;
  icon?: React.ReactNode;
  onClear: () => void;
}

interface FilterSummaryProps {
  filters: ActiveFilter[];
  onClearAll: () => void;
  title?: string;
  clearAllLabel?: string;
}

const FilterSummary: React.FC<FilterSummaryProps> = ({
  filters,
  onClearAll,
  title = "Applied Filters",
  clearAllLabel = "Clear All",
}) => {
  if (filters.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 px-4 py-2 bg-gray-50/50 rounded-xl border border-gray-100">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm font-medium text-gray-500 mr-2">{title}:</span>
        <div className="flex flex-wrap items-center gap-2">
          {filters.map((filter) => (
            <Badge
              key={filter.id}
              color="gray"
              size="sm"
              className="pl-1 pr-2 py-1 flex items-center gap-1 group bg-white border border-gray-200 text-gray-700"
            >
              <div className="flex items-center gap-1.5">
                {filter.icon && (
                  <div className="flex items-center shrink-0">
                    {filter.icon}
                  </div>
                )}
                <span className="max-w-[150px] truncate text-xs font-medium">
                  {filter.label}
                </span>
                <button
                  onClick={filter.onClear}
                  className="p-0.5 hover:bg-gray-100 rounded-full transition-colors ml-1 text-gray-400 hover:text-gray-600"
                  title={`Clear ${filter.label}`}
                >
                  <XIcon size={12} weight="bold" />
                </button>
              </div>
            </Badge>
          ))}
        </div>
      </div>

      <button
        onClick={onClearAll}
        className="text-sm font-medium text-blue-600 hover:text-blue-700 flex items-center gap-2 px-3 py-1.5 hover:bg-blue-50 rounded-lg transition-all"
      >
        <ArrowCounterClockwise size={16} weight="bold" />
        <span>{clearAllLabel}</span>
      </button>
    </div>
  );
};

export default FilterSummary;
